"use client";

import useQueryWithPages from "src/hooks/useQueryWithPages";

export const useAccounts = () => {
  const { isError, isPlaceholderData, isLoading, data, pagination } = useQueryWithPages({
    resourceName: "addresses",
  });

  return { isError, isPlaceholderData, isLoading, data, pagination };
};
